<template>
  <div id="contratacao">
    <Header v-if="appSettings.header.enable"></Header>
    <b-container>
      <Loader v-if="isLoading" />
      <b-row v-if="notFoundDevice">
        <Feedback />
      </b-row>
      <b-row v-else>
        <b-col sm="12" md="6" class="deviceImg">
          <figure v-if="mainImage">
            <img
              :class="`deviceImg__${
                deviceDetails.deviceTypeName &&
                deviceDetails.deviceTypeName.toLowerCase()
              }`"
              :src="mainImage"
              alt="Imagem do aparelho"
            />
            <figcaption>{{ disclaimer }}</figcaption>
          </figure>
        </b-col>
        <b-col sm="12" md="6" class="box-infos">
          <div class="info-aparelho">
            <p class="seguro">Seguro para o aparelho:</p>
            <h1 class="aparelho" v-if="!loadingData">{{ deviceDetails.name }}</h1>
            <div v-else class="loading loading__header"></div>
          </div>
          <div class="cotacao">
            <p class="valor" v-if="!loadingData">
              <span class="parcelas">{{ installmentLabel }}</span>
              <br />
              <span v-if="precoDefault" v-bind:class="{ promo: promoClass }"
                >R${{
                  precoDefault[precoPromo.length - 1].preco.replace(
                    ".",
                    ","
                  )
                }}</span
              >
              <span v-if="precoPromo && promoClass">
                R${{
                  precoPromo[precoPromo.length - 1].preco.replace(
                    ".",
                    ","
                  )
                }}</span
              >
            </p>
            <div v-else>
              <div class="loading loading__installment"></div>
              <div class="loading loading__price"></div>
            </div>
            <div v-if="showPartnerDiscountCard" class="partner-discount">
              <div class="partner-discount-label">
                <img class="partner-logo" :src=" appSettings.partner.badge || appSettings.partner.logo" alt="Logo Parceiro">
                <strong>Desconto aplicado</strong>
                <img src="~@/assets/svg/check.svg" alt="Desconto Check">
              </div>
              <div class="partner-text">
                <p> Clientes da <strong>{{ appSettings.partner.name }}</strong> têm desconto nos produtos Ciclic</p>
              </div>
            </div>
            <div v-if="isPartnerLivelo" class="selo-livelo">
              <img src="https://ciclic.imgix.net/logo/livelo.webp?auto=format,compress&w=31&h=31" alt="Logo livelo">
              Ganhe <strong>{{scorePoints}}</strong> pontos Livelo <br>
            </div>
            <div v-if="isPartnerDotz" class="selo-dotz">
              <img src="https://ciclic.imgix.net/logos/logo_dotz.png?auto=format,compress" alt="Logo Dotz">
              Ganhe <strong>{{scorePoints}}</strong> pontos Dotz <br>
            </div>
            <div class="cobertura">
              <p class="cobertura-contra">Você estará coberto contra:</p>
            </div>
            <Icons
              :icon="somenteRoubo ? disabled : resume"
              :iconV="somenteRoubo ? iconx : iconv"
              :iconvOrx="somenteRoubo"
            />
            <v-checkbox
              label="Somente contra roubo e furto"
              color="success"
              hide-details
              v-model="somenteRoubo"
              @change="mountDetails(originalData)"
            ></v-checkbox>
            <template v-if="appSettings.promoCode.enable">
              <PromoCode
                v-if="uuid && !loadingData"
                :uuid="uuid"
                :promoCode="promoCodeFromParams"
                @applied="mountDetails"
                @canceled="promoCodeCanceled"
              />
              <div class="loading__promo-code" v-else>
                <div class="loading loading__promo-code__label"></div>
                <div class="loading loading__promo-code__input"></div>
                <div class="loading loading__promo-code__feedback"></div>
              </div>
            </template>

            <b-button
              id="btn-contratar-portateis"
              class="quero-proteger"
              v-if="!mobile"
              :disabled="!precoDefault"
              @click="goToCadastro()"
              pill
              variant="danger"
              size="lg"
            >
              CONTRATAR
            </b-button>
            <b-button
              id="btn-contratar-portateis"
              class="quero-proteger"
              v-else-if="mobile"
              :disabled="!precoDefault"
              @click="goToCadastro()"
              pill
              variant="danger"
              size="lg"
            >
              CONTRATAR
            </b-button
            >
          </div>
          <div class="cotacao">
            <div class="cobertura">
              <p class="mais-informacoes">
                O seguro possui carência de 30 dias a partir da contratação. No sinistro, aplica-se franquia no valor de R$ {{deviceDetails.franchise}} (25% do valor do aparelho em até 4x). Confira detalhes nas <span><a :href="`${generalConditionsUrl}/Ciclic_SeguroCelular_Condicoes.pdf`" target="_blank">Condições Gerais</a></span>.
              </p>
              <div class="social-medias">
                <span class="compartilhe-cotacao">Compartilhe sua cotação:</span>
                <span class="icones-compartilhar">
                  <WhatsApp
                    :url="url"
                    scale="3"
                    title="Confira nossa cotação"
                  />
                </span>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { WhatsApp } from 'vue-socialmedia-share'

import Header from '../Header/Header'
import Icons from '@/components/Icons/Icons'
import PromoCode from '@/components/PromoCode'
import Loader from '@/components/Loader'
import Feedback from '@/components/Contratacao/Feedback'

import { getDataProduct, getPromoCode } from '@/api/services.js'

import './Contratacao.css'

export default {
  name: 'Contratacao',
  components: {
    Header,
    Icons,
    PromoCode,
    Loader,
    WhatsApp,
    Feedback
  },
  data () {
    return {
      isPartnerLivelo: false,
      isPartnerDotz: false,
      scorePoints: 0,
      somenteRoubo: false,
      uuid: '',
      deviceDetails: { name: '' },
      device: [],
      fullPayment: [],
      parcialPayment: [],
      selectedData: null,
      numeroParcela: 12,
      precoDefault: null,
      precoPromo: null,
      package: '',
      product: '',
      premium: '',
      originalData: null,
      promoClass: false,
      mobile: false,
      generalConditionsUrl: '',
      iconx: 'icon-x', // variável que irá passar a cor pro icone X
      iconv: 'icon-v', // Variável que irá passar a cor pro icone v
      disabled: 'disabled icon-resume',
      resume: 'icon-resume',
      url: `Confira nossa cotação! ${window.location.href}`,
      oldValues: {},
      isLoading: false,
      notFoundDevice: false,
      loadingData: false
    }
  },
  async mounted () {
    this.uuid = this.$route.query.id
    this.mobile = window.screen.width <= 450
    this.package = 'default'
    this.product = 'celular'
    this.generalConditionsUrl = process.env.VUE_APP_CHICO_XAVIER

    sessionStorage.removeItem('ciclic:checkout')

    this.loadingData = true
    const getData = (await this.appSettings.promoCode.autoApply)
      ? getPromoCode({
          uuid: this.uuid,
          promoCode: this.appSettings.promoCode.code,
          isRenovation: false
        })
      : getDataProduct({ uuid: this.uuid, isRenovation: false })

    getData
      .then((response) => {
        if (!response.data || !response.data.DEFAULT || !response.data.PROMO) {
          this.notFoundDevice = true
          this.$sentry.logWithContext({
            ctx: { step: '[step/contracting]: error data', data: response.data },
            error: new Error('[step/contracting]: error data')
          })
          return
        }
        this.recalculateInstallments(response.data)
        this.mountDetails({
          ...response.data,
          ...(this.appSettings.promoCode.autoApply && {
            promoCode: this.appSettings.promoCode.code
          })
        })
        this.oldValues = response.data
        /*  this.mountLivelo(response.data) */
        this.loadCategoryPage(response.data)
      })
      .catch((error) => {
        this.$sentry.logWithContext({
          ctx: { step: '[step/contracting]: error ' }, error
        })
      }).finally(() => {
        this.loadingData = false
      })
  },
  computed: {
    ...mapState(['appSettings', 'params', 'lead', 'minimalInstallmentValue']),
    installmentLabel () {
      const isPromoFirstInstallmentOff = false
      return isPromoFirstInstallmentOff
        ? '0+11x sem juros de'
        : 'Valor mensal'
    },
    mainImage () {
      const isValidFileUrl = (/\.(gif|jpe?g|tiff?|png|webp|bmp)$/i).test(this.deviceDetails.imageSrc)
      const url = isValidFileUrl ? this.deviceDetails.imageSrc : ''
      const urlWithParams = url.includes('ciclic.imgix.net') ? `${url}?auto=compress,format` : url
      return urlWithParams
    },
    disclaimer () {
      const isImageFromApple = this.mainImage.toLowerCase().includes('apple')
      return isImageFromApple ? '* Imagem meramente ilustrativa. Fonte: Apple' : '* Imagem meramente ilustrativa.'
    },
    promoCodeFromParams () {
      const { promoCode } = this.$route.query || this.params
      return promoCode
    },
    showPartnerDiscountCard () {
      return this.appSettings.promoCode &&
        !this.appSettings.promoCode.enable &&
        this.appSettings.partner &&
        this.appSettings.partner.name !== 'Ciclic' &&
        this.appSettings.partner.logo
    }
  },
  methods: {
    ...mapActions(['actionPatchLead']),
    async recalculateInstallments (data) {
      const pricingStyles = ['DEFAULT', 'PROMO']
      const paymentOptions = ['completePaymentOptions', 'theftPaymentOptions']

      // Checking if the installments are above the minimum
      pricingStyles.forEach((pricingStyle) => {
        paymentOptions.forEach((paymentOption) => {
          const lastInstallment = data[pricingStyle][paymentOption].length - 1
          if (data[pricingStyle][paymentOption][lastInstallment] >= this.minimalInstallmentValue) return
          // split the array where the installment is below the minimum
          const splitIndex = data[pricingStyle][paymentOption].findIndex((item) =>
            item < this.minimalInstallmentValue
          )
          data[pricingStyle][paymentOption] = data[pricingStyle][paymentOption].slice(0, splitIndex)
        })
      })
    },
    mountDetails (data) {
      this.$store.commit('phoneDetail', data.DEFAULT)

      this.originalData = data
      this.fullPayment = []
      this.parcialPayment = []
      this.deviceDetails = data.DEFAULT

      this.deviceDetails.completePaymentOptions.map((cell, index) => {
        return this.fullPayment.push({ parcela: index + 1, preco: cell })
      })

      this.deviceDetails.theftPaymentOptions.map((cell, index) => {
        return this.parcialPayment.push({ parcela: index + 1, preco: cell })
      })

      this.precoDefault = this.somenteRoubo
        ? this.parcialPayment
        : this.fullPayment
      this.selectedData =
        this.precoDefault[this.precoDefault.length - 1]

      if (
        this.originalData.PROMO.scoringProgram &&
        this.originalData.PROMO.scoringProgram.pointsLivelo) {
        this.isPartnerLivelo = true
        if (this.somenteRoubo) {
          this.scorePoints = this.originalData.PROMO.scoringProgram.pointsLivelo.theftPrice
        } else {
          this.scorePoints = this.originalData.PROMO.scoringProgram.pointsLivelo.completePrice
        }
      }

      if (
        this.originalData.PROMO.scoringProgram &&
        this.originalData.PROMO.scoringProgram.pointsDotz) {
        this.isPartnerDotz = true
        if (this.somenteRoubo) {
          this.scorePoints = this.originalData.PROMO.scoringProgram.pointsDotz.theftPrice
        } else {
          this.scorePoints = this.originalData.PROMO.scoringProgram.pointsDotz.completePrice
        }
      }

      if (data.PROMO) {
        this.$store.commit('phoneDetail', data.PROMO)

        this.fullPayment = []
        this.parcialPayment = []
        this.deviceDetails = data.PROMO

        this.deviceDetails.completePaymentOptions.map((cell, index) => {
          return this.fullPayment.push({ parcela: index + 1, preco: cell })
        })

        this.deviceDetails.theftPaymentOptions.map((cell, index) => {
          return this.parcialPayment.push({ parcela: index + 1, preco: cell })
        })

        this.precoPromo = this.somenteRoubo
          ? this.parcialPayment
          : this.fullPayment
        this.selectedData =
          [this.precoDefault.length - 1]
        this.promoClass = true
      }

      if (data.promoCode) {
        this.promoCode = data.promoCode
      }
    },
    promoCodeCanceled () {
      this.mountDetails(this.oldValues)
    },
    async goToCadastro () {
      this.isLoading = true

      this.$store.commit('change', this.appSettings.maxInstallment)

      await this.actionPatchLead({
        amount: Number(this.precoPromo.at(0).preco),
        ...(this.promoCode && { promocode: this.promoCode.toUpperCase() })
      })

      const data = {
        cookieGA: this.params._ga,
        default: this.originalData.DEFAULT,
        promo: this.originalData.PROMO,
        promoBag: this.originalData.PROMO_BAG,
        lead: this.lead,
        device: this.deviceDetails,
        precoPromo: this.precoPromo,
        parcela: this.appSettings.maxInstallment,
        scorePoints: this.scorePoints,
        isPartnerLivelo: this.isPartnerLivelo,
        isPartnerDotz: this.isPartnerDotz,
        promoCode: this.promoCode,
        somenteRoubo: this.somenteRoubo,
        ...(this.appSettings.campaign && {
          campaign: this.appSettings.partner.slug
        })
      }

      this.$store.commit('changeQuotedDevice', data)

      const eventCellphone = {
        event: 'celular-ciclic',
        categoria: 'celular-cotacao',
        acao: 'plano-selecionado',
        rotulo: this.somenteRoubo ? 'Roubo' : 'Roubo, Líquido e Quebra'
      }

      const eventDevice = {
        event: 'dispositivos-ciclic',
        categoria: 'coberturas',
        acao: 'click',
        rotulo: this.somenteRoubo ? 'THEFT' : 'COMPLETE'
      }

      window.dataLayer.push(process.env.VUE_APP_PRODUCT_NAME === 'seguro-equipamentos-portateis' ? eventDevice : eventCellphone)

      setTimeout(() => {
        this.$router.push({ name: 'ProtectedBag' })
      }, 1000)
    },
    loadCategoryPage (data) {
      window.dataLayer.push({
        event: 'afiliattionTag',
        level: 'productPage',
        productName: data.DEFAULT.uuid,
        productDetail: data.DEFAULT.name,
        productAmount: data.PROMO.completePrice,
        productURL: window.location.href,
        productCurrency: 'BRL'
      })
    }
  }
}
</script>
<style scoped>
  .selo-livelo{
    margin-top: 24px;
  }

  .selo-dotz{
    margin-top: 24px;
  }

  .selo-dotz img{
    max-height: 32px;
    margin-right: 8px;
  }
  .partner-discount{
  margin-top: 30px;
}

.partner-discount-label{
  border: solid 1px #00CC67;
  border-radius: 8px;
  padding: 12px 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 20px;
}
.partner-discount-label .partner-logo{
  max-width: 70px;
}

.partner-text{
  margin-top: 15px;;
  border-bottom: 1px solid rgba(150, 180, 205, 0.24);
  font-size: 14px;
}

.loading {
  background: rgb(201,201,201);
  background: linear-gradient(90deg, rgba(201,201,201,1) 0%, rgba(255,255,255,1) 28%, rgba(175,175,175,1) 67%, rgba(255,255,255,1) 100%) 0 0 / 200% 100% fixed;
  opacity: 0.5;
  animation: loading 5s infinite;
}
.loading__header {
  height: 42px;
  margin-block: 10px;
}
.loading__installment {
  height: 31px;
  width: 197px;
  margin-top: 24px;
  margin-bottom: 10px;
}
.loading__price {
  height: 62px;
  width: 256px;
}

.loading__promo-code {
  margin-bottom: 12px;
  margin-top: 21px;
}

.loading__promo-code__label {
  height: 24px;
  width: 150px;
  margin-bottom: 8px;
}

.loading__promo-code__input {
  height: 42px;
  width: 100%;
  margin-bottom: 8px;
}

.loading__promo-code__feedback {
  height: 18px;
  width: 185px;
}

@keyframes loading {
  to {
    background-position: -200% 0;
  }
}

</style>
